resourcePaths = '{"rootPath":"","assetsPath":""}';function Notification () {
  this.id = null;
  this.node = null;
  this._$node = null;
  this.declaredClass = null;
  this.extends = [_ResponsiveLayout];
  this.content = null;
  this.openSpeed = 400;
  this.closeSpeed = 400;
  this.clearParamTime = 5000;
  this.states = {
    success: { className: 'notification--success' },
    error: { className: 'notification--error' },
    warning: { className: 'notification--warning' },
    timeout: { className: 'notification--timeout' },
    custom: { className: 'notification--custom' }
  };
  this.validNotificationTypes = [
    this.states.success,
    this.states.error,
    this.states.warning,
    this.states.timeout,
    this.states.custom
  ];

  // Selector for the Navigation (#Navigation)
  this.navigation = null;

  this.el = {};
  this._classes = {
    notificationContent: '.notification__content',
    close: '.js--close-btn'
  };
  this._notificationDescriber = null;
  this._hideNotificationTimeout = null;

  this.init = function () {
    this._$node = $(this.node);

    this.setupContent();
    this._setupAnalytics();

    this.registerResponsiveFunction(this.setPositioning.bind(this), null, null);
  };

  this.initAllReady = function () {};

  this.setupContent = function () {
    this._$node.append(
      '<div class="notification__content"></div>',
      '<a class="js--close-btn notification__close-btn"><svg class="svg-icon" viewBox="0 0 20 20"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close2"></use></svg></a>'
    );

    this.el.content = this._$node.find(this._classes.notificationContent);
    this.el.close = this._$node.find(this._classes.close);
    this.el.close.on('click', this.hideNotification);
  };

  this.setPositioning = function () {
    if (!this._isOverlayShown()) {
      var top = $(this.navigation).outerHeight();
      this._$node.css('top', top ? top + 'px' : '0px');
    }
  };

  this._isOverlayShown = function () {
    var dialog = $('body').children('.mogo-ui-dialog-overlay').hasClass('shown');
    var portalOverlay = $('body').find('.portal__overlay').is(':visible');
    return (dialog || portalOverlay);
  };

  this.get = function (notificationMsg) {
    // keeping this.get for backwards compat only.  (sunset when you can)
    this.create({});
  };

  this.create = function (settings) {
    // Get defaults if setting not specified:
    var msg = settings.msg
      ? settings.msg
      : 'Uh oh! Something went wonky—try again.';
    var type = settings.type ? this.states[settings.type] : this.states.warning; // default to type 'warning'
    var isPersistent = settings.isPersistent ? settings.isPersistent : false;
    var customClass = settings.customClass ? settings.customClass : '';
    this._notificationDescriber = settings.notificationDescriber;

    this._show(type, msg, isPersistent, customClass);
  };

  this._show = function (
    notificationType,
    notificationMsg,
    isPersistent,
    customClass
  ) {
    this._resetNotification();

    if (this.validNotificationTypes.indexOf(notificationType) !== -1) {
      var wrapperClass =
        'notification ' +
        notificationType.className +
        ' notification--is-displayed ' +
        customClass;

      if (notificationType === this.states.custom) {
        this.el.content.html(notificationMsg);
      } else {
        this.el.content.text(notificationMsg);
      }

      // if a dialog is open bump up the z-index
      if (this._isOverlayShown()) {
        this._$node.addClass('notification--is-over-dialog');
      }
      this._$node.addClass(wrapperClass).hide().slideDown(this.openSpeed);
      this._pushAnalytics('Shown');

      // Show the Message for a period of time
      if (!isPersistent) {
        this._hideNotificationTimeout = setTimeout(this.hideNotification, this.clearParamTime);
      }
      // Cleans URL
      setTimeout(
        this._resetURL.bind(this, notificationType, 'Notification'),
        this.clearParamTime
      );
    } else {
      throw 'Invalid notificationType given: ' +
        JSON.stringify(notificationType) +
        '; must use one of Notification.(success|error|warning|timeout|custom)';
    }
  };

  this._resetNotification = function () {
    this._$node.removeClass();
    this.el.content.empty();
  };

  this.hideNotification = function (speed) {
    if (this._hideNotificationTimeout) { clearTimeout(this._hideNotificationTimeout); }
    if (speed && speed.type == 'click') {
      this._pushAnalytics('Closed By User');
    } else {
      this._pushAnalytics('Closed By Timer');
    }
    var _speed = speed !== 'undefined' ? speed : this.closeSpeed;
    this._$node.slideUp(
      _speed,
      function () {
        this._resetNotification();
      }.bind(this)
    );
  }.bind(this);

  this._resetURL = function (data, title) {
    window.history.replaceState(data, title, window.location.pathname);
  };

  this._setupAnalytics = function () {
    this.analytics = new Analytics();
    this.analytics.extendEventObject({
      'component-notification-event': {
        'event': function (type) {
          return 'DLevent.' + type.charAt(0).toUpperCase() + type.slice(1) + 'Notification';
        },
        'notification': function (identifier) {
          return window.location.pathname + '/' + identifier;
        },
        'notificationAction': function (action) {
          return action;
        }
      }
    });
  };

  this._pushAnalytics = function (action) {
    var type = 'custom';
    for (var key in this.states) {
      if (key !== 'custom' && this._$node.hasClass(this.states[key]['className'])) {
        type = key;
        break;
      }
    }
    var identifier = this._notificationDescriber ? type + '/' + this._notificationDescriber : type;
    this.analytics.pushEvent('component-notification-event', {
      'event': [type],
      'notification': [identifier],
      'notificationAction': [action]
    });
  };
}
